import React, { useState } from 'react';
import axios from 'axios';
import { Alert, Button, Form, Modal } from 'react-bootstrap';

export default function EvolucoesOdontologicasPanel({
  pacienteId,
  consultaId,
  evolucoes = [],
  onChanged
}) {
  const initialFormState = {
    dente: '',
    face: '',
    descricao: '',
    materiais_medicamentos: '',
    intercorrencias: '',
    orientacoes: '',
    finalizar: true
  };

  const [form, setForm] = useState(initialFormState);
  const [parent, setParent] = useState(null);
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');

    try {
      await axios.post(`/api/odontologia/pacientes/${pacienteId}/evolucoes`, {
        ...form,
        consulta_id: consultaId || null
      });
      setForm(initialFormState);
      await onChanged?.();
    } catch (x) {
      setError(x.response?.data?.message || 'Não foi possível registrar a evolução.');
    } finally {
      setBusy(false);
    }
  };

  const add = async () => {
    if (!parent?.id) return;
    setBusy(true);
    setError('');

    try {
      await axios.post(`/api/odontologia/evolucoes/${parent.id}/adendos`, {
        descricao: text
      });
      setParent(null);
      setText('');
      await onChanged?.();
    } catch (x) {
      setError(x.response?.data?.message || 'Não foi possível registrar o adendo.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      {error && (
        <Alert variant="danger" dismissible onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      <Form className="odonto-form" onSubmit={save}>
        <div className="form-row d-flex gap-2 mb-2">
          <Form.Control
            placeholder="Dente"
            value={form.dente}
            onChange={e => handleInputChange('dente', e.target.value)}
          />
          <Form.Control
            placeholder="Face"
            value={form.face}
            onChange={e => handleInputChange('face', e.target.value)}
          />
        </div>

        <Form.Group className="mb-2">
          <Form.Control
            as="textarea"
            rows={3}
            required
            placeholder="Descrição clínica *"
            value={form.descricao}
            onChange={e => handleInputChange('descricao', e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-2">
          <Form.Control
            as="textarea"
            rows={2}
            placeholder="Materiais e medicamentos"
            value={form.materiais_medicamentos}
            onChange={e => handleInputChange('materiais_medicamentos', e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-2">
          <Form.Control
            as="textarea"
            rows={2}
            placeholder="Intercorrências"
            value={form.intercorrencias}
            onChange={e => handleInputChange('intercorrencias', e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-2">
          <Form.Control
            as="textarea"
            rows={2}
            placeholder="Orientações"
            value={form.orientacoes}
            onChange={e => handleInputChange('orientacoes', e.target.value)}
          />
        </Form.Group>

        <Alert variant="info" className="my-2">
          Ao registrar, a evolução será finalizada e não poderá ser editada. Correções serão feitas por adendo.
        </Alert>

        <Button type="submit" disabled={busy} variant="primary">
          {busy ? 'Salvando...' : 'Registrar evolução finalizada'}
        </Button>
      </Form>

      <hr className="my-4" />

      <div className="timeline">
        {evolucoes.map(ev => (
          <article key={ev.id} className="mb-3 p-3 border rounded">
            <div>
              <b>
                {ev.created_at ? new Date(ev.created_at).toLocaleString('pt-BR') : 'Data N/I'} · {ev.profissional?.nome || 'Profissional'}
              </b>
            </div>
            <p className="mb-1">
              {ev.dente && <strong>Dente {ev.dente} · </strong>}
              {ev.descricao}
            </p>
            <span className="text-muted small d-block mb-2">Finalizada — conteúdo original imutável</span>
            
            <Button
              size="sm"
              variant="outline-secondary"
              onClick={() => setParent(ev)}
            >
              Adicionar adendo
            </Button>

            {(ev.adendos || []).map(a => (
              <div
                key={a.id}
                style={{
                  marginTop: 10,
                  padding: 10,
                  borderLeft: '3px solid #0ea5e9',
                  background: '#f0f9ff'
                }}
              >
                <b>
                  Adendo · {a.created_at ? new Date(a.created_at).toLocaleString('pt-BR') : 'Data N/I'}
                </b>
                <p className="mb-0">{a.descricao}</p>
              </div>
            ))}
          </article>
        ))}
      </div>

      <Modal show={!!parent} onHide={() => setParent(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Adendo à evolução</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="warning">
            O texto original será preservado. O adendo ficará identificado com autor, data e hora.
          </Alert>
          <Form.Control
            as="textarea"
            rows={4}
            value={text}
            onChange={e => setText(e.target.value)}
            placeholder="Descreva a correção ou informação complementar"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setParent(null)}>
            Cancelar
          </Button>
          <Button disabled={busy || !text.trim()} onClick={add} variant="primary">
            {busy ? 'Gravando...' : 'Registrar adendo'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}